import {
  CREATE_WEEKLY_SOLAR_REPORT,
  DELETE_WEEKLY_SOLAR_REPORT,
  EDIT_WEEKLY_SOLAR_REPORT,
  RECEIVE_WEEKLY_SOLAR_REPORTS,
  REQUEST_WEEKLY_SOLAR_REPORT,
} from '@sophocles/entities/WeeklySolarReport/weeklySolarReportActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_WEEKLY_SOLAR_REPORTS: // Read
      return state.merge(action.weeklySolarReports);
    case DELETE_WEEKLY_SOLAR_REPORT: // Delete
      return state.delete(action.weeklySolarReport.toString());
    case EDIT_WEEKLY_SOLAR_REPORT: // Update
    case CREATE_WEEKLY_SOLAR_REPORT: // Create
    case REQUEST_WEEKLY_SOLAR_REPORT:
    default:
      return state;
  }
}

export function weeklySolarReportReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_WEEKLY_SOLAR_REPORT:
    case DELETE_WEEKLY_SOLAR_REPORT:
    case RECEIVE_WEEKLY_SOLAR_REPORTS:
    case EDIT_WEEKLY_SOLAR_REPORT:
    case REQUEST_WEEKLY_SOLAR_REPORT:
      return getState(state, action);
    default:
      return state;
  }
}
